import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useGuestAuthAction } from '@/hooks/useGuestAuthAction';
import { clientPaths } from '@/utils/clientPaths';
import { useUnreadNotifications } from '@/hooks/useNotifications';

interface NotificationBellProps {
  tone?: 'light' | 'dark';
}

export function NotificationBell({ tone = 'dark' }: NotificationBellProps) {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const runGuestAware = useGuestAuthAction();
  const { data: hasUnread } = useUnreadNotifications(isAuthenticated);
  const iconClass = tone === 'light' ? 'text-white' : 'text-[#0E1726]';
  const hoverClass = tone === 'light' ? 'hover:bg-white/15' : 'hover:bg-gray-100';

  return (
    <button
      type="button"
      onClick={() => runGuestAware(() => navigate(clientPaths.notification))}
      className={`relative w-10 h-10 rounded-full flex items-center justify-center ${hoverClass} transition-colors cursor-pointer shrink-0`}
      aria-label="Notifikasi"
    >
      <Icon icon="ph:bell" className={`w-6 h-6 ${iconClass}`} />
      {isAuthenticated && hasUnread ? (
        <span className="absolute top-2 right-2 w-2 h-2 rounded-full bg-red-500" />
      ) : null}
    </button>
  );
}
